import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async paginateList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan-detail.paginate'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getTreeList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan-detail.get-tree-list'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getList({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan-detail.get-list'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getPrefectures({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.forest-management-plan-detail.get-prefectures'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getListByProjectId({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.forest-management-plan-detail.get-list-by-project-id'),
      payload
    )
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
  async getStandardCuttingAgeOptions({ commit }, payload) {
    const apiResult = await apiService.post(
      route('member.fcs.forest-management-plan-detail.get-standard-cutting-age-options'),
      payload
    )
    if (apiResult && apiResult.success) {
      return apiResult.data
    }
    return false
  },
}

export default {
  state,
  mutations,
  actions,
}
